import React from "react";
import Link from "next/link";

import { Strain } from "custom-types/Strain";
import { useEventTracker } from "hooks/useEventTracker";

import ButtonPlaceholder from "components/ButtonPlaceholder";

type Props = {
  strain: Strain;
  hasMenuItems?: boolean | undefined;
  trackingCategory: string;
  trackingAction: string;
  trackingLabel: string;
};

const StrainCardAccessoryTray: React.FC<Props> = ({
  strain,
  hasMenuItems,
  trackingCategory,
  trackingAction,
  trackingLabel,
}) => {
  const { publishEvent } = useEventTracker();

  return (
    <div className="m-md mt-none">
      {hasMenuItems === true && (
        <Link
          href={{
            pathname: "/shop",
            query: {
              "filter[strain_name]": strain.name,
              fulfillmentPreference: "pickup",
            },
          }}
          data-testid="strain-card-strain-buy-button"
          className="button"
          onClick={(event) => {
            event.stopPropagation();
            publishEvent({
              action: trackingAction,
              category: trackingCategory,
              label: trackingLabel,
              strainId: strain.id,
            });
          }}
        >
          shop menus
        </Link>
      )}
      {hasMenuItems === false && (
        <Link
          data-testid="strain-card-strain-link-button"
          className="button button--secondary"
          onClick={(event) => {
            event.stopPropagation();
            publishEvent({
              action: trackingAction,
              category: trackingCategory,
              label: trackingLabel,
              strainId: strain.id,
            });
          }}
          href={`/strains/${strain.slug}`}
        >
          learn more
        </Link>
      )}
      {hasMenuItems === undefined && <ButtonPlaceholder height="36" />}
    </div>
  );
};

export default StrainCardAccessoryTray;
